export const PNL_TRANSACTION_REPORT = "PNL_TRANSACTION_REPORT";
export const STOCK_DETAILS_SUMMARY = "STOCK_DETAILS_SUMMARY";
export const PNL_TRANSACTION_ERROR = "PNL_TRANSACTION_ERROR";
export const PNL_TRANSACTION_HIDE_ERROR = "PNL_TRANSACTION_HIDE_ERROR";
export const PNLTXN_EMPTY_VALIDATION = "PNLTXN_EMPTY_VALIDATION";
export const PNLTXN_HIDE_EMPTY_VALIDATION = "PNLTXN_HIDE_EMPTY_VALIDATION";
export const PNL_TRANSACTION_SHOW_SHIMMER = "PNL_TRANSACTION_SHOW_SHIMMER";
export const EDIT_SPLIT_TXN_LOADER = "EDIT_SPLIT_TXN_LOADER";
export const PNL_ORIGINAL_TXNS = "PNL_ORIGINAL_TXNS";
export const PNL_ORIGINAL_TXNS_LOADER = "PNL_ORIGINAL_TXNS_LOADER";
